import { render } from "./OtherDetailsSizeDetailsView.vue?vue&type=template&id=c9a978f8"
import script from "./OtherDetailsSizeDetailsView.vue?vue&type=script&lang=js"
export * from "./OtherDetailsSizeDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__